import countries from '@/countriesList'

const removeCountriesWithoutCallingCode = (vueContextTranslate) => {
  return countries
    .map((item) => {
      if (item.callingCodes.length && item.callingCodes[0] !== '') {
        return {
          value: item.callingCodes[0],
          label: `+${item.callingCodes[0]} ${item.name}`,
          name: vueContextTranslate.$t(`general.components.selects.countries.${item.name}`),
          flag: item.flag,
        }
      }
    })
    .filter((country) => country)
    .sort((countryA, countryB) => {
      if (countryA.label < countryB.label) {
        return -1
      }
      if (countryA.label > countryB.label) {
        return 1
      }
      return 0
    })
}

const CallingCodeMoreFlag = (vueContextTranslate) => {
  return countries
    .map((item) => {
      if (item.callingCodes.length && item.callingCodes[0] !== '') {
        return {
          value: item.callingCodes[0],
          label: `+${item.callingCodes[0]}`,
          flag: item.flag,
          name: item.name,
        }
      }
      vueContextTranslate
    })
    .filter((country) => country)
    .sort((countryA, countryB) => {
      if (countryA.name < countryB.name) {
        return -1
      }
      if (countryA.name > countryB.name) {
        return 1
      }
      return 0
    })
}

const nameCountries = (vueContextTranslate) => {
  return countries
    .map((item) => {
      return {
        vies: item.vies,
        value: item.code,
        flag: item.flag,
        label: vueContextTranslate.$t(`general.components.selects.countries.${item.name}`),
      }
    })
    .sort((countryA, countryB) => {
      if (countryA.label < countryB.label) {
        return -1
      }
      if (countryA.label > countryB.label) {
        return 1
      }
      return 0
    })
}

export { removeCountriesWithoutCallingCode, CallingCodeMoreFlag, nameCountries }
